"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const isNotificationImportant_1 = __importDefault(require("./isNotificationImportant"));
function renderNotifications(notifications, onSelect, extraNotificationData, hasSelected) {
    const isNecessaryDataMissing = !notifications ||
        !Array.isArray(notifications) ||
        !Object.keys(extraNotificationData).length;
    if (isNecessaryDataMissing)
        return [];
    const target = [...notifications]
        .sort((a, b) => {
        const isAImportant = (0, isNotificationImportant_1.default)(a.type, a.message, a.user, a.group);
        const isBImportant = (0, isNotificationImportant_1.default)(b.type, b.message, b.user, b.group);
        switch (true) {
            case isAImportant && !isBImportant:
                return -1;
            case !isAImportant && isBImportant:
                return 1;
            default:
                return b.timestamp - a.timestamp;
        }
    })
        .map(notification => {
        const data = extraNotificationData[notification.identifier];
        const important = !!(data === null || data === void 0 ? void 0 : data.important);
        const selected = !!(data === null || data === void 0 ? void 0 : data.selected);
        const isGroup = !!(notification === null || notification === void 0 ? void 0 : notification.group);
        const key = notification.identifier;
        const args = {
            key,
            notification,
            important,
            selected,
            isGroup,
            onSelect,
            hasSelected,
        };
        return (0, index_1.getNotificationByType)(args);
    });
    return target;
}
exports.default = renderNotifications;
